<template>
  <div>
    <Slide>
      <div class="menu-list" v-if="!loading">
        <div>
          <a to="/dashboard/profile" class="menu-user" @click="toProfile">
            <img
              src="https://habrastorage.org/getpro/moikrug/uploads/company/100/005/154/6/logo/medium_6543b62af5976af1c18ad2d88cd4a9b3.jpg"
            >
            <div class="user-info" v-if="!$store.state.company.uid">
              <strong>{{ name }}</strong>
              <span>{{ position || roles[role] }} <i class="fas fa-chevron-right"></i></span>
            </div>
            <div class="user-info" v-else>
              <strong>{{ $store.state.company.name }}</strong>
              <span>Компания <i class="fas fa-chevron-right"></i></span>
            </div>
          </a>
          <template v-if="!$store.state.company.uid">
            <a class="project-name menu-li" @click="navigate('/dashboard/')">
              {{ $store.state.project.name }}
              {{ $store.state.project.plan ? `- ${$store.state.project.plan.name}` : '' }}
              {{ $store.state.project.version ? `- ${$store.state.project.version.name}` : '' }}
            </a>
            <a class="menu-li" @click="toReport">
              <span><img src="@/assets/icon/otch.svg" class="icon-menu"> Отчеты</span>
              <i class="fas fa-chevron-right"></i>
            </a>
            <a class="menu-li" v-if="this.$store.state.project.tasks || this.$store.state.project.workorder" @click="navigate('/dashboard/tasksMenu')">
              <span><img src="@/assets/icon/zadach.svg" class="icon-menu"> Задачи</span>
              <i class="fas fa-chevron-right"></i>
            </a>
            <a class="menu-li" @click="navigate('/dashboard/analytics')">
              <span><img src="@/assets/icon/analit.svg" class="icon-menu"> Аналитика</span>
              <i class="fas fa-chevron-right"></i>
            </a>
            <a class="menu-li docs" @click="navigate('/dashboard/docs')">
              <span><img src="@/assets/icon/dock.svg" class="icon-menu"> Документация</span>
              <i class="fas fa-chevron-right"></i>
            </a>
            <!--        <a v-if="role==='admin'"  class="menu-li" @click="navigate('/dashboard/work_type')">-->
            <!--          <span>Виды работ</span>-->
            <!--          <i class="fas fa-chevron-right"></i>-->
            <!--        </a>-->
            <a v-if="role ==='admin' && !usePermission" class="menu-li" @click="navigate('/dashboard/settings')">
              <span><img src="@/assets/icon/setup.svg" class="icon-menu"> Настройки проекта</span>
              <i class="fas fa-chevron-right"></i>
            </a>
            <a class="menu-li all-projects" @click="navigate('/dashboard/projects')">
              <span><img src="@/assets/icon/all-projects.svg" class="icon-menu"> Все проекты</span>
              <i class="fas fa-chevron-right"></i>
            </a>

            <a v-if="isSuper" class="menu-li admin" @click="navigate('/dashboard/clients')">
              <span>Клиенты</span>
              <i class="fas fa-chevron-right"></i>
            </a>

            <a class="menu-li" href="https://stroybots.ru/support" target="_blank">
              <span><img src="@/assets/icon/help.svg" class="icon-menu"> Помощь</span>
            </a>
          </template>
          <template v-else>
            <a class="menu-li" @click="navigate('/dashboard/reports')">
              <span>Отчеты</span>
              <i class="fas fa-chevron-right"></i>
            </a>
            <a class="menu-li" @click="clearCompany">
              <span>Вернутся в свой профиль</span>
              <i class="fas fa-chevron-right"></i>
            </a>
          </template>
        </div>

        <div class="exit-li" @click="signOut">Выход</div>
      </div>
    </Slide>
    <ReportModal v-if="openDialog" is-version :open-dialog="openDialog" @close="openDialog = false"/>
  </div>
</template>

<script>
import {Slide} from 'vue-burger-menu';
import firebase from 'firebase';
import {resetInit} from '../utils/getItemsForUser';
import ReportModal from "../views/Dashboard/Reports/components/ReportModal";

export default {
  name: 'Menu',
  components: {ReportModal, Slide},
  data() {
    return {
      loading: false,
      firebase,
      role: 'admin',
      usePermission: false,
      position: null,
      openDialog: false,
      roles: {
        'admin': 'Администратор',
        'worker': 'Работник',
        'editor': 'Редактор',
      },
      name: '',
      isSuper: false,
      user: {
        name: authFirestore.currentUser.email,
      },
      currentUser: authFirestore.currentUser,
    };
  },
  mounted() {
    myFirestore.collection('superuser').where('user', '==', authFirestore.currentUser.uid).get()
      .then(async (data) => {
        if (data.size) {
          this.isSuper = true;
        }
      });
    setTimeout(() => {
      this.fetchUser();
    }, 1500);
  },
  watch: {
    '$store.state.project.id': {
      immediate: true,
      handler() {
        this.loading = true;
        this.fetchUser();
        myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id).get().then((sub) => {
          const data = sub.data();
          if (data) {
            const rules = data.rules;
            if (rules) {
              this.role = rules[authFirestore.currentUser.uid];
              if (data.isDemo) {
                this.role = 'admin';
              }
              this.loading = false;
            }
          }
        });
      },
    },
  },
  methods: {
    toReport() {
      if(this.$store.state.project.version && this.$store.state.project.version.id) {
        return this.openDialog = true
      }
      this.navigate('/dashboard/reports')
    },
    clearCompany() {
      localStorage.removeItem('company');
      this.$store.dispatch('clearCompany')
    },
    toProfile() {
      if (!this.$store.state.company.uid) {
        this.navigate('/dashboard/profile');
      }
    },
    fetchUser() {
      this.loading = true;
      let name = '';
      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('users')
        .where('uid', '==', authFirestore.currentUser.uid)
        .get()
        .then(async (data) => {
          await data.forEach((subDoc) => {
            const user = subDoc.data();
            name = user.name && user.name.length ? user.name : authFirestore.currentUser.email;
            this.position = user.position;

            if(this.$store.state.project.owner !== authFirestore.currentUser.uid) {
              this.usePermission = !!user.usePermission;
            }

          });
          this.name = name;
        }).finally(() => {
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    signOut() {
      authFirestore.signOut().then(() => {
        resetInit();
        this.$router.push('/');
      });
    },
    navigate(name) {
      this.$router.push(name);
      document.querySelector('.bm-cross-button').click();
    },
  },
};
</script>

<style lang="scss">
.bm-burger-button {
  position: fixed !important;
  width: 26px !important;
  height: 20px !important;
  left: 20px !important;
  //top: 46px !important; // IOS ONLY
  top: 16px !important;

  cursor: pointer !important;
  z-index: 9;
}

.bm-burger-bars {
  background-color: #fff !important;
  height: 2px !important;
}

.line-style {
  position: absolute !important;
  left: 0 !important;
  right: 0 !important;
}

.cross-style {
  position: absolute;
  top: 12px;
  right: 2px;
  cursor: pointer;
}

.exit-li {
  font-size: 16px;
  color: #777;
  cursor: pointer;
  margin: 32px 0 0px;
  padding-bottom: 40px;

  &:hover {
    color: #c0392b;
  }
}

.bm-cross {
  background: #bdc3c7;
}

.menu-li {
  display: flex;
  justify-content: space-between;
  padding: 0 15px;
  align-items: center;
  font-size: 16px;
  height: 54px;
  font-weight: 500;
  color: #000;
  text-decoration: none;

  span {
    display: flex;
    align-items: center;
  }

  img {
    margin-right: 8px;
  }

  i {
    color: #999;
  }

  &:hover {
    background: #CfCfCf;
  }
}

.menu-user {
  display: flex;
  align-items: center;
  text-decoration: none;

  img {
    width: 48px;
    height: 48px;
  }

  .user-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    strong {
      font-size: 16px;
      color: #000;
    }

    span {
      font-size: 14px;
      color: #555;
    }
  }
}

.bm-cross-button {
  height: 24px !important;
  width: 24px !important;
  right: 15px !important;
  //margin-top: 34px !important; // IOS ONLY
  margin-top: 4px;

  .bm-cross {
    height: 22px !important;
    background: #979da1 !important;;
  }
}

.project-name {
  background: #f2f2f2;
  height: 50px;
  margin-top: 4px !important;
  align-items: center !important;
  color: #000;

  &:hover {
    background: #f2f2f2;
  }
}

.bm-menu {
  height: 100% !important;
  width: 0;
  position: fixed; /* Stay in place */
  z-index: 1000 !important; /* Stay on top */
  top: 0 !important;
  left: 0 !important;
  background: #FFFFFF !important;
  border-right: 1px solid rgba(0, 0, 0, 0.1) !important;
  overflow-x: hidden; /* Disable horizontal scroll */
  padding-top: 10px !important;
  transition: 0.5s; /*0.5 second transition effect to slide in the sidenav*/
}

.bm-overlay {
  background: rgba(0, 0, 0, 0) !important;
}

.menu-list {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.all-projects {
  color: #4883F2;
  font-weight: 600;

  i {
    color: #4883F2;
  }
}

.admin {
  color: green;
  font-weight: 600;

  i {
    color: green;
  }
}

.bm-item-list, .menu-list {
  padding: 0 !important;
  margin: 0 !important;
  height: 100% !important;
}

.help {
  margin-bottom: 32px;
  font-size: 16px;
  text-decoration: none;
  color: #555;
}
//
//.menu-user {  // IOS ONLY
//  margin-top: 28px !important;
//  margin-bottom: 14px !important;
//}
</style>



// WEBPACK FOOTER //
// src/components/Menu.vue